import { z } from 'zod/v4';

import { productAssignmentSchema } from './product-assignment.schema';
import { userVehicleSchema } from './user-vehicle.schema';

export const userSchema = z.object({
  id: z.number().min(1),
  externalId: z.string().min(1),
  email: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  linkedExternalId: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  assignments: z.array(productAssignmentSchema),
  vehicles: z.array(userVehicleSchema).nullable(),
});

export const userImportSchema = userSchema
  .pick({
    externalId: true,
    email: true,
    firstName: true,
    lastName: true,
    phoneNumber: true,
  })
  .extend({ externalName: z.string() });

export type User = z.infer<typeof userSchema>;

export type UserImport = z.infer<typeof userImportSchema>;
